import { Link } from "react-router-dom";
import {useSelector} from "react-redux";
import { useEffect } from "react";

const UserProfile = () => {
    
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    console.log('profie user', user)
  }, [user])
  return (
    <div className="max-w-xl mx-auto bg-white rounded-2xl shadow-md border border-gray-100 p-4 sm:p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-base sm:text-lg font-semibold text-[#003399]">
          My Profile
        </h1>

        <Link
          to="/profile/edit"
          className="text-xs sm:text-sm bg-[#003399] text-white px-4 py-2 rounded-lg hover:opacity-90 transition"
        >
          Edit Profile
        </Link>
      </div>

      {/* Profile Section */}
      <div className="flex flex-col items-center mb-6">
        <img
          src={user?.avatar || "/user-avatar.webp"}
          alt="Profile"
          className="w-24 h-24 rounded-full object-cover border"
        />

        <p className="mt-3 text-sm sm:text-base font-semibold text-gray-800">
          {user?.firstName} {user?.lastName}
        </p>

        <p className="text-xs text-gray-500">
          {user?.Group?.name || "No Society"}
        </p>
      </div>

      {/* Details */}
      <div className="space-y-4">
        <ProfileRow label="Name" value={user?.firstName +" "+user.lastName } />
        <ProfileRow label="Email" value={user?.email} />
        <ProfileRow label="Phone Number" value={user?.phone} />
        <ProfileRow
          label="Society"
          value={user?.Group?.name || "—"}
        />
      </div>
    </div>
  );
};

/**
 * 🔁 Reusable row
 */
const ProfileRow = ({ label, value }) => (
  <div className="flex justify-between items-center border rounded-xl px-4 py-3">
    <p className="text-xs sm:text-sm text-gray-500">{label}</p>
    <p className="text-sm font-medium text-gray-800 truncate">{value}</p>
  </div>
);

export default UserProfile;
